import React, { useState } from 'react';
import {
  Drawer,
  IconButton,
  Box,
  Typography,
  Divider,
  Fab,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { FilterList, Close as CloseIcon } from '@mui/icons-material';
import MobileDemandFilters from '@/features/demands/components/MobileDemandFilters';
import DemandsSearchField from '@/features/demands/components/DemandsSearchField';
import MobileReportsFilters from '@/features/reports/MobileReportsFilters';
import MobileClientOnlyFilters from './MobileClientOnlyFilters';
import { ROUTES } from '@/constants';
import { useLocation } from 'react-router-dom';

interface MobileFiltersDrawerProps {
  showDemandFilters: boolean;
}

const MobileFiltersDrawer: React.FC<MobileFiltersDrawerProps> = ({ showDemandFilters }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const isReportsPage = location.pathname === ROUTES.APP_REPORTS;
  // Pedido do usuário (03/09 e 04/09): páginas condomínio-scoped usam o mesmo filtro do
  // cabeçalho, só com a opção de condomínio — ver ClientOnlyFilters/MobileClientOnlyFilters.
  // Pedido do usuário (14/09): /app/suggestions virou redirect pra /app/public-panel (já coberto
  // abaixo) — Sugestões não tem mais filtro próprio (MobileSuggestionsFilters removido).
  const isClientOnlyFilterPage =
    location.pathname === ROUTES.APP_CHECKLISTS ||
    location.pathname === ROUTES.APP_PATRIMONY ||
    location.pathname === ROUTES.APP_QR_CODES ||
    location.pathname === ROUTES.APP_RECURRING_DEMANDS ||
    location.pathname === ROUTES.APP_SUGGESTION_BOX ||
    location.pathname === ROUTES.APP_PUBLIC_PANEL;

  if (!isMobile || !showDemandFilters) {
    return null;
  }

  return (
    <>
      <Fab
        onClick={() => setOpen(true)}
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 16,
          zIndex: 1000,
        }}
        color="primary"
        aria-label="filtros"
      >
        <FilterList />
      </Fab>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxHeight: '85vh',
          },
        }}
      >
        <Box sx={{ p: 2, pb: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
              Filtros
            </Typography>
            <IconButton onClick={() => setOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <Divider sx={{ mb: 3 }} />
          {isReportsPage ? (
            <MobileReportsFilters />
          ) : isClientOnlyFilterPage ? (
            <MobileClientOnlyFilters />
          ) : (
            <>
              <Box sx={{ mb: 2 }}>
                <DemandsSearchField fullWidth />
              </Box>
              <MobileDemandFilters />
            </>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default MobileFiltersDrawer;

